const arrayToObject = (array, keyField) => {
    return array.reduce((obj, item) => {
        obj[item[keyField]] = item;
        return obj;
    }, {});
};

// is value is numeric
const isNumeric = (value) => {
  return !Number.isNaN(Number(value)) && value !== "";
};

export { isNumeric };

export default arrayToObject;
